module.exports = "<div class=\"example\">\n    <img src=\"<%-exampleImg%>\">\n</div>\n<form class=\"form-horizontal\">\n    <div class=\"form-group text-center\">\n        <h4>Click \"save\" to add add the date and time of generation to your report.</h4>\n    </div>\n</form>\n";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/modals/reports/modify_widgets/datetimewidget/datetimewidget.html
// module id = 804
// module chunks = 7